import t from"./engine-v8-version.js";import e from"./fails.js";var r=t,n=e,m=!!Object.getOwnPropertySymbols&&!n(function(){var o=Symbol();return!String(o)||!(Object(o)instanceof Symbol)||!Symbol.sham&&r&&r<41});export{m as default};
